export const PAYMENT_STATUS_PENDING = 'pending';
export const PAYMENT_STATUS_SUCCEED = 'succeed';
export const PAYMENT_STATUS_FAILED = 'failed';
export const PAYMENT_STATUS_CANCELLED = 'cancelled';
// Written by the new Online Store: a manual payment the customer sent for staff to approve,
// and attempts that never completed (no money taken).
export const PAYMENT_STATUS_PENDING_REVIEW = 'pending_review';
export const PAYMENT_STATUS_REQUIRES_ACTION = 'requires_action';
export const PAYMENT_STATUS_INITIATING = 'initiating';
export const PAYMENT_STATUS_PROCESSING = 'processing';
export const PAYMENT_STATUS_EXPIRED = 'expired';
// A payment the card's bank later reversed: money was taken, then returned.
export const PAYMENT_STATUS_CHARGED_BACK = 'charged_back';

export const PAYMENT_ID_CASH = 'CASH';
export const PAYMENT_ID_PAYNOW = 'PAYNOW';
export const PAYMENT_ID_PAYNOW_STRIPE = 'PAYNOW_STRIPE';
export const PAYMENT_ID_CREDIT = 'CREDIT';
export const PAYMENT_ID_POINTS = 'POINTS';
export const PAYMENT_ID_STRIPE = 'STRIPE';
export const PAYMENT_ID_GRABPAY = 'GRABPAY';
export const PAYMENT_ID_WECHATPAY = 'WECHATPAY';
export const PAYMENT_ID_ALIPAY = 'ALIPAY';